import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function BlogSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            SEO Guides
          </h2>
          <p className="font-heading text-2xl md:text-4xl font-light text-foreground-600 mt-1">
            for Ecommerce Sellers
          </p>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              onClick={() => window.scrollTo(0, 0)}
              className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300/40 transition-all duration-200 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-400 mb-3">
                  {article.date} &middot; {article.readTime}
                </p>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="mt-10 text-center">
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-foreground-700 border border-background-300 rounded-md hover:bg-background-200/70 hover:text-foreground-950 transition-colors cursor-pointer"
          >
            Read Full Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}